import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { ReservationLedger, ReservationLedgerParams } from './reservationLedger.types';

export const getReservationLedgerList = (client: AxiosInstance) => async (params: ReservationLedgerParams) => {
  return (
    await client.get<PaginatedApiResponse<ReservationLedger[]>>(API_ROUTES.GET_RESERVATION_LEDGER_LIST, { params })
  ).data;
};

export const reservationLedgerQueries = {
  all: () => ['reservation-ledger'],
  list: (params: ReservationLedgerParams) =>
    queryFactoryOptions<PaginatedApiResponse<ReservationLedger[]>>({
      queryKey: [...reservationLedgerQueries.all(), 'list', params],
      queryFn: (client) => () => getReservationLedgerList(client)(params),
    }),
};
